import React from "react";
import "./Main.css";
const CustomButton = ({
  onClick,
  title,
  color,
  fontSize,
  width,
  textColor,
}) => {
  const height = window.innerHeight;
  const heightiPhone6s = height <= 667;

  const buttonHeight = heightiPhone6s ? 35 : 45;
  const buttonFontSize = heightiPhone6s
    ? fontSize
      ? fontSize - 3
      : 14
    : fontSize || 18;

  const defaultColor = color || "#333"; // Reemplaza con tu Constants.LGREEN si querés
  const defalutTextColor = textColor || "#fff";
  return (
    <button
      onClick={onClick}
      style={{
        margin: "10px",
        width: width || "250px",
        height: `${buttonHeight}px`,
        borderRadius: "50px",
        border: "1px solid rgba(255,255,255,.62)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: defaultColor,
        background: `linear-gradient(145deg, rgba(255,255,255,.48), color-mix(in srgb, ${defaultColor} 72%, transparent) 42%, color-mix(in srgb, ${defaultColor} 88%, #001f1d))`,
        boxShadow: `inset 0 2px 1px rgba(255,255,255,.58), inset 0 -5px 10px rgba(0,0,0,.2), 0 7px 0 color-mix(in srgb, ${defaultColor} 58%, #001f1d), 0 14px 25px rgba(0,0,0,.32)`,
        backdropFilter: "blur(12px) saturate(145%)",
        WebkitBackdropFilter: "blur(12px) saturate(145%)",
        cursor: "pointer",
        fontSize: `${buttonFontSize}px`,
        fontWeight: "bold",
        color: defalutTextColor,
        textShadow: "0 1px 3px rgba(0,0,0,.65)",
        textAlign: "center",
        fontFamily: "Roboto-Regular",
      }}
    >
      {title}
    </button>
  );
};

export default CustomButton;
